<template>
  <HonorarDiagramm
    v-if="typeUp === 'hn'"
    :file="fileUp"
    :inPrint="inPrint"
    :inDownload="inDownload"
    @download-pdf="downloadPDF"
  />
  <FgDiagramm
    v-if="typeUp === 'fg'"
    :file="fileUp"
    :inPrint="inPrint"
    :inDownload="inDownload"
    @download-pdf="downloadPDF"
  />
</template>

<script>
let typeIn = typeof type !== "undefined" ? type : "fg";
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get("type")) typeIn = urlParams.get("type");

const fileIn =
  typeof file !== "undefined"
    ? file
    : "http://localhost:8080/ips_honorarbericht.xlsx";

import { Chart as ChartJS } from "chart.js";
import * as html2pdf from "html2pdf.js";
import { ref } from "vue";

import HonorarDiagramm from "@/components/HonorarDiagramm";
import FgDiagramm from "@/components/FgDiagramm";

export default {
  name: "App",
  components: { HonorarDiagramm, FgDiagramm },
  setup() {
    const typeUp = typeIn;
    const fileUp = fileIn;
    const inPrint = ref(false);
    const inDownload = ref(true);

    const dOpts =
      typeUp === "hn"
        ? {
            margin: [10, 10, 0, 0],
            width: 1400,
            windowWidth: 3500,
          }
        : {
            margin: [5, 5, 0, 0],
            width: 1200,
            windowWidth: 3500,
          };

    const downloadPDF = () => {
      //    inPrint.value = true;
      inDownload.value = true;
      //      beforePrint();#
      var element = document.getElementById("honorardiagramm");
      element.classList.add("indownload");
      const opt = {
        filename: "Honorarberichte.pdf",
        margin: dOpts.margin,
        useCORS: true,
        html2canvas: {
          scale: 1,
          imageTimeout: 10,
          logging: false,
          width: dOpts.width,
          windowWidth: dOpts.windowWidth,
        },
        pagebreak: {
          mode: ["css", "legacy"],
        },
        jsPDF: {
          unit: "mm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
        },
      };
      setTimeout(() => {
        html2pdf()
          .from(element)
          .set(opt)
          .toPdf()
          .get("pdf")
          .save()
          .then(() => {
            inPrint.value = false;
            inDownload.value = false;
            element.classList.remove("indownload");
          });
      }, 600);
    };

    const beforePrint = () => {
      inPrint.value = true;
      document.getElementById("maincontent").classList.add("inprint");
      for (var id in ChartJS.instances) {
        ChartJS.instances[id].resize();
      }
    };

    window.addEventListener("beforeprint", (event) => {
      beforePrint();
    });

    window.addEventListener("afterprint", (event) => {
      document.getElementById("maincontent").classList.remove("inprint");
      inPrint.value = false;
    });

    return {
      typeUp,
      fileUp,
      inPrint,
      inDownload,
      downloadPDF,
    };
  },
};
</script>
